import React from 'react';

import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
  linkClasses,
  tooltipClasses,
  typographyClasses,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export interface TooltipProps extends MuiTooltipProps {
  className?: string;
}

export const Tooltip: React.ComponentType<TooltipProps> = styled(
  (props: TooltipProps) => (
    <MuiTooltip
      {...props}
      arrow
      classes={{ popper: props.className }}
      slotProps={{
        popper: {
          sx: {
            maxWidth: '296px',
          },
        },
      }}
    />
  ),
  {
    name: 'Tooltip',
    shouldForwardProp: (prop) => prop !== 'className',
  },
)<TooltipProps>(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...tokens.typography.bodySRegular,
    padding: '8px 12px',
    backgroundColor: theme.palette.colors.bg['neutral-primary'],
    color: theme.palette.colors.content['primary-inverted'],
    borderRadius: '8px',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
    [`.${typographyClasses.root}:not(.${linkClasses.root})`]: {
      color: theme.palette.colors.content['primary-inverted'],
    },
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.colors.bg['neutral-primary'],
  },
  [`&[data-popper-placement="right-start"] .${tooltipClasses.arrow}`]: {
    top: '8px!important',
  },
  [`&[data-popper-placement="right-end"] .${tooltipClasses.arrow}`]: {
    top: '-8px!important',
  },

  [`&[data-popper-placement="left-start"] .${tooltipClasses.arrow}`]: {
    top: '8px!important',
  },
  [`&[data-popper-placement="left-end"] .${tooltipClasses.arrow}`]: {
    top: '-8px!important',
  },

  [`&[data-popper-placement="top-start"] .${tooltipClasses.arrow}`]: {
    left: '8px!important',
  },
  [`&[data-popper-placement="top-end"] .${tooltipClasses.arrow}`]: {
    left: '-8px!important',
  },

  [`&[data-popper-placement="bottom-start"] .${tooltipClasses.arrow}`]: {
    left: '8px!important',
  },
  [`&[data-popper-placement="bottom-end"] .${tooltipClasses.arrow}`]: {
    left: '-8px!important',
  },
}));
